export const generateFieldId = (formName, sectionName, fieldName, component) =>
  `${formName}-${sectionName}-${fieldName}-${component}`;


